module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.href) ? _c('a', {
    staticClass: "button",
    class: _vm.containerClass,
    attrs: {
      "href": _vm.isLink
    },
    on: {
      "mouseenter": _vm._isEnter,
      "focus": _vm._isEnter,
      "blur": _vm._isLeave,
      "click": _vm._isClick,
      "mouseleave": _vm._isLeave
    }
  }, [(_vm.hasIcon) ? [_c('span', {
    staticClass: "icon",
    class: _vm.iconClass
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._t("default")], 2)], 2) : _c('button', {
    staticClass: "button",
    class: _vm.containerClass,
    attrs: {
      "type": _vm.type
    },
    on: {
      "mouseenter": _vm._isEnter,
      "focus": _vm._isEnter,
      "blur": _vm._isLeave,
      "click": _vm._isClick,
      "mouseleave": _vm._isLeave
    }
  }, [(_vm.hasIcon) ? [_c('span', {
    staticClass: "icon",
    class: _vm.iconClass
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._t("default")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74194148!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SimpleButton.vue
// module id = 142
// module chunks = 1